import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OrderComponent } from '../../order-manager/order/order.component';

@Component({
    selector: 'app-recall-confirmation',
    templateUrl: './recall-confirmation.component.html',
    styleUrls: ['./recall-confirmation.component.css'],
    standalone: false
})
export class RecallConfirmationComponent {

    constructor(public dialogRef: MatDialogRef<OrderComponent>) {}

    cancel() {
        this.dialogRef.close(false);
    }

    confirm() {
        this.dialogRef.close(true);
    }
}
